import{getUnitDescription as t,getUnitPreference as e}from"../../../utils/index.js";function i(){return"imperial"===t(e("length")).system}export{i as getIsImperial};
